import PropTypes from "prop-types";
import { formatDateRange } from "../../utils/dateFormatting";

export const DateRangeLabel = ({ startDate, endDate, handleClick }) => {
  return (
    <button
      onClick={handleClick}
      style={{
        background: "#f5f8fc",
        padding: "6px 10px",
        borderRadius: "8px",
        color: "#48566B",
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        cursor: "pointer",
        border: "none",
      }}
    >
      {formatDateRange(startDate)}
      {endDate && ` - ${formatDateRange(endDate)}`}
    </button>
  );
};

DateRangeLabel.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  handleClick: PropTypes.func,
};
